import VCombobox from './VCombobox';
export { VCombobox };
export default VCombobox;
//# sourceMappingURL=index.js.map